<template>
	<DashboardModal
		ref="modal"
		width="500px"
		:class="$style['pop-up-info-modal']"
		@modal-toggle="close"
	>
		<!-- <DashboardFormTitle>
      <span>{{ $t('common.fields.more-info') }}</span>
    </DashboardFormTitle> -->
		<div :class="$style['pop-up-info-modal__content']">
			<slot />
		</div>
	</DashboardModal>
</template>

<script>
import DashboardModal from '@/components/Layout/Dashboard/Modal'
// import DashboardFormTitle from '@/components/Layout/Dashboard/Form/FormTitle'

export default {
	name: 'PopUpInfo',
	components: {
		DashboardModal
		// DashboardFormTitle
	},

	methods: {
		close () {
			this.$emit('closed')
		}
	}
}
</script>
<style lang="scss" module>
.pop-up-info-modal {
    &__content-wrapper {
        padding: 10px 0;
    }

    &__content {
        h1 {
            font-size: 24px;
        }

        h2 {
            font-size: 20px;
        }

        h3 {
            font-size: 18px;
        }

        pre {
            padding: 0.7rem 1rem;
            border-radius: 5px;
            background: getColor(surface-elevated-high);
            color: getColor(text);
            font-size: 0.8rem;
            overflow-x: auto;

            code {
                display: block;
            }
        }

        blockquote {
            border-left: 3px solid getColor(border);
            color: getColor(sub-text);
            padding-left: 0.8rem;
            font-style: italic;

            p {
                margin: 0;
            }
        }

        p code {
            padding: 0.2rem 0.4rem;
            border-radius: 5px;
            font-size: 0.8rem;
            font-weight: bold;
            background: getColor(chip-light);
            color: getColor(text);
        }
    }

    &__content-list {
        margin: 0;
        padding: 20px;
        padding-bottom: 0;
    }

    &__content-list-item {
        margin-bottom: 20px;
    }

    &__buttons {
        display: flex;
        margin: 0 -20px;
        margin-top: 10px;
    }

    &__button {
        margin: 0 20px;
    }
}
</style>
